import e from"styled-components";import{theme as i}from"../../../theme.js";const n=e.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  > span {
    font-size: 14px;
    color: ${i.colors.gray[900]};
    margin-left: ${i.spacing*2}px;
  }
`,o=e.div`
  width: 20px;
  height: 20px;
  margin-right: ${i.spacing*-1}px;
  position: relative;
  > svg {
    width: 20px;
    height: 20px;
  }
  &.like {
    z-index: 5;
  }
  &.love {
    z-index: 4;
  }
  &.haha {
    z-index: 3;
  }
  &.angry {
    z-index: 2;
  }
  &.emotional {
    z-index: 1;
  }
`;export{n as Container,o as Icon};
